import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap";
import { Modal, Table, notification } from "antd";
import DataService from "../../services/requestApi";
import JsonToXlsxDownload from "../../utils/JsonToXlsxDownload";
import moment from "moment";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AddApplicant from "components/Applicant/AddApplicant";
import { CallUpdateStatus } from "services/apiAction";

const School = () => {
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const initialPage = Number(queryParams.get("page")) || 1;
  const initialLimit = Number(queryParams.get("limit")) || 20;
  const initialSearch = queryParams.get("search") || "";

  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(initialSearch);
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [totalCounts, setTotalCounts] = useState(0);
  const [schoolCounts, setSchoolCounts] = useState(0);
  const [studentCounts, setStudentCounts] = useState(0);

  const [pageData, setPageData] = useState({
    pageNo: initialPage,
    limit: initialLimit,
    role: "school",
  });

  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    school_name: "",
    school_city: "",
    school_code: "",
    role: "school",
  });

  const updateURL = (page, limit, searchTerm) => {
    const params = new URLSearchParams();
    params.set("page", page);
    params.set("limit", limit);
    if (searchTerm) params.set("search", searchTerm);

    navigate(`?${params.toString()}`, { replace: true });
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      updateURL(pageData.pageNo, pageData.limit, search);
      setPageData((prev) => ({ ...prev, pageNo: pageData.pageNo }));
      fetchData(pageData.pageNo, pageData.limit, search);
    }, 600);

    return () => clearTimeout(delay);
  }, [search]);

  useEffect(() => {
    updateURL(pageData.pageNo, pageData.limit, search);
    fetchData(pageData.pageNo, pageData.limit, search);
  }, [pageData.pageNo, pageData.limit]);

  const fetchData = async (page = 1, limit = 20, searchTerm = "") => {
    try {
      setLoading(true);

      const query = {
        pageNo: page,
        limit: limit,
        role: "school",
        search: searchTerm,
      };

      const { data } = await DataService.FindAllUsersByParams(query);

      if (data?.message === "Success") {
        const newData = data?.admin.map((item, index) => ({
          ...item,
          key: index,
        }));

        setData(newData);
        setTotalCounts(data?.totalCount || 0);
        setSchoolCounts(data?.schoolCount || 0);
        setStudentCounts(data?.studentCount || 0);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  const CreatAdmin = async (e) => {
    e.preventDefault();
    try {
      setIsSubmit(true);

      const { data } = await DataService.CreateAdmin(JSON.stringify(userData));

      if (data?.message === "Success") {
        api.success({ message: "Created Successfully", duration: 2 });

        setUserData({
          firstName: "",
          lastName: "",
          email: "",
          mobile: "",
          password: "",
          school_name: "",
          school_city: "",
          school_code: "",
          role: "school",
        });

        fetchData(pageData.pageNo, pageData.limit, search);
        setModal(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmit(false);
    }
  };

  const handleEdit = async (id, status, name) => {
    try {
      const formdata = new FormData();
      formdata.append(name === "status" ? "status" : "isChecked", !status);

      const { data } = await CallUpdateStatus(id, formdata);

      if (data.message === "Success") {
        fetchData(pageData.pageNo, pageData.limit, search);
        api.success({ message: data.message, duration: 2 });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const columns = [
    {
      title: "Sr No.",
      key: "_id",
      render: (id, data, idx) =>
        idx + 1 + pageData.limit * (pageData.pageNo - 1),
    },
    {
      title: "Name",
      key: "name",
      render: (id, item) => `${item.firstName} ${item.lastName}`,
    },
    { title: "Mobile", dataIndex: "mobile", key: "mobile" },
    { title: "Email", dataIndex: "email", key: "email" },
    {
      title: "Created Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => moment(created_at).format("ll"),
    },
    {
      title: "Status",
      render: (id, item) => (
        <Label className="custom-toggle custom-toggle-warning">
          <Input
            type="checkbox"
            onClick={() => handleEdit(item._id, item.status, "status")}
            defaultChecked={item.status}
          />
          <span className="custom-toggle-slider rounded-circle" />
        </Label>
      ),
    },
    {
      title: "Checked",
      render: (id, item) => (
        <Label className="custom-toggle custom-toggle-warning">
          <Input
            type="checkbox"
            onClick={() => handleEdit(item._id, item.isChecked, "checked")}
            defaultChecked={item.isChecked}
          />
          <span className="custom-toggle-slider rounded-circle" />
        </Label>
      ),
    },
    {
      title: "Action",
      render: (id, item) => (
        <Button
          tag={Link}
          to="/admin/school/adminListing"
          state={{ schoolId: item._id, role: "school" }}
          size="sm"
          color="white"
        >
          <i className="fas fa-eye text-primary" />
        </Button>
      ),
    },
  ];

  return (
    <Container className="my-5" fluid>
      {contextHolder}

      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0 pb-0 d-flex justify-content-between flex-wrap">
              <div className="d-flex align-items-center">
                <h3 className="mb-2 mb-sm-0">School List</h3>

                <Card className="p-1 mb-0 ml-3" style={{ backgroundColor: "#f7fafc" }}>
                  <span className="mr-3 font-weight-bold">
                    Total Schools:{" "}
                    <Button color="primary" className="ml-3 mr--3" size="sm">
                      {schoolCounts}
                    </Button>
                  </span>
                </Card>
                <Card className="p-1 mb-0 ml-3" style={{ backgroundColor: "#f7fafc" }}>
                  <span className="mr-3 font-weight-bold">
                    Total Students:{" "}
                    <Button color="primary" className="ml-3 mr--3" size="sm">
                      {studentCounts}
                    </Button>
                  </span>
                </Card>
              </div>
              <div className="d-flex align-items-center gap-2">
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => setModal(true)}
                  className="mr-3 p-2"
                >
                  Add_School
                </Button>

                <JsonToXlsxDownload jsonData={data} pageName="SchoolListing" />

                <Input
                  placeholder="Search"
                  value={search}
                  type="search"
                  className="rounded rounded-pill"
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </CardHeader>

            <CardBody>
              <Table
                dataSource={data}
                columns={columns}
                loading={loading}
                scroll={{ x: "max-content" }}
                pagination={{
                  current: pageData.pageNo,
                  pageSize: pageData.limit,
                  total: totalCounts,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  onChange: (page, pageSize) =>
                    setPageData({ ...pageData, pageNo: page, limit: pageSize }),
                }}
              />
            </CardBody>
          </Card>
        </div>
      </Row>

      <Modal
        title="Add School"
        open={modal}
        onCancel={() => setModal(false)}
        footer={null}
        width={600}
      >
        <AddApplicant
          handleChange={handleChange}
          createAdmin={CreatAdmin}
          loading={isSubmit}
          userData={userData}
        />
      </Modal>
    </Container>
  );
};

export default School;